<script>
/**
 * @file 首页
 */
import Footer from './footer.vue';
import ForkissIcon from './forkiss-icon';
import mixin from './mixins_api';


export default {
    mixins: [mixin],
    components: {
        Footer,
        ForkissIcon
    },
    created() {
        this.getBanner().then(res => {
            let list = res.result || [];
            this.bannerList = list.filter(v => !!v.pic).sort((a, b) => (b.sorting - a.sorting));
        });

        this.getMyOrder({
            type: 'latest'
        }).then(res => {
            if (res.result.length > 0) {
                this.latestClass = res.result[0] || {};
            }
        });
    },
    mounted() {
    },
    methods: {
        goto(name) {
            this.$router.push({name});
        },
        viewPlan() {
            this.$router.push({
                name: 'my-center'
            });
        }
    },
    data() {
        return {
            userInfo: {},
            bannerList: [],
            latestClass: {},
            swiperOptions: {
                loop: true,
                initialSlide: 0,
                effect : 'slide',
                speed: 800,
                direction : 'horizontal',
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                }
            }
        };
    }
}
</script>

<template lang="pug">
.forkiss-home-container
    .home-header
        img(src="../assets/home-logo.png")
    .home-main-content
        .important-hint-box
            .important-hint
                .hint-title
                    span 上课提醒
                template(v-if="latestClass.id")
                    .hint-content {{latestClass.title}}
                    ForkissIcon.hint-time(icon="forkiss-icon-time") {{latestClass.start_time | date("YYYY-mm-dd HH:MM")}}
                    ForkissIcon.hint-address(icon="forkiss-icon-address") {{latestClass.room_name}}
                template(v-else)
                    .hint-content 暂无待上课程
                    a.hint-link-name(data-touch="true", @click="goto('pregnancy')") 立即约课
            .view-all-box
                a.view-all(data-touch="true", @click="goto('public-order')") 全部已约课程
        .carousel-box
            swiper.my-swiper-container(ref="mySwiper", :options="swiperOptions",
                v-if="bannerList && bannerList.length > 0",)
                swiper-slide(v-for="banner in bannerList", :key="banner.id")
                    img.slider-img(:src="banner.pic")
                div(class="swiper-pagination", slot="pagination")

        .order-clasess-box(data-touch="true", @click="goto('pregnancy')")
            a.link-name 立即约课
        .view-plan-box(data-touch="true", @click="viewPlan")
            a.link-name 查看套餐
    Footer(activeId="home", :category="userInfo.category")
</template>

<style lang="less" scoped>
.forkiss-home-container {
    position: relative;
    background: #F7F7F7;
    color: #333;
    padding-bottom: 1rem;
    font-size: .24rem;

    .home-header {
        height: 3.64rem;
        padding-top: 0.72rem;
        background: #c59869;
        color: #FFF;
        text-align: center;
        font-size: .6rem;

        img {
            width: 2.49rem;
        }
    }

    .home-main-content {
        margin-top: -1.65rem;
        padding: 0 .3rem;

    }

    .important-hint {
        width: 100%;
        height: 3.18rem;
        background: #FFF;
        border-radius: .1rem;
        padding: .48rem .64rem 0;
        // background-image: url(../assets/home-bg1.png);
        background-image: url(../assets/home-banner.jpg);
        background-repeat: no-repeat;
        background-size: contain;
        background-position: right;

        .hint-title {
            position: relative;
            color: #c59869;
            text-align: center;
            font-size: .26rem;
            font-weight: 600;
            margin-bottom: .4rem;

            &::before {
                content: "";
                display: inline-block;
                vertical-align: middle;
                width: .24rem;
                height: .24rem;
                background-image: url(../assets/double-slant.svg);
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center;
            }

            &::after {
                content: "";
                display: inline-block;
                vertical-align: middle;
                width: .24rem;
                height: .24rem;
                background-image: url(../assets/double-slant.svg);
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center;
            }

            span {
                display: inline-block;
                vertical-align: middle;
                margin: 0 .2rem;
            }
        }
        .hint-content {
            margin-bottom: .2rem;
            font-size: .36rem;
            font-weight: 600;
            color: #a4805b;
        }
        .hint-link-name {
            color: #a4805b;
            font-weight: 500;

            &::after {
                content: "";
                display: inline-block;
                width: .22rem;
                height: .16rem;
                transform: rotate(180deg);
                background-image: url(../assets/arrow.svg);
                background-repeat: no-repeat;
                background-size: contain;
                margin-left: .08rem;
            }
        }
        .hint-time {
            color: #666;

            span {
                display: inline-block;
                vertical-align: middle;
            }
        }
        .hint-address {
            color: #666;

            span {
                display: inline-block;
                vertical-align: middle;
            }
        }

    }

    .view-all-box {
        margin-top: .24rem;
        margin-bottom: .32rem;
        text-align: right;

        .view-all {
            color: #a4805b;
            font-weight: 500;

            &::after {
                content: "";
                display: inline-block;
                width: .22rem;
                height: .16rem;
                transform: rotate(180deg);
                background-image: url(../assets/arrow.svg);
                background-repeat: no-repeat;
                background-size: contain;
                margin-left: .08rem;
            }
        }
    }


    .carousel-box {
        position: relative;
        overflow: hidden;
        background: #d9d9d9;
        border-radius: .1rem;
        margin-bottom: .2rem;

        .my-swiper-container {
            width: 100%;
            height: 2.45rem;
            // 自定义翻页组件样式
            .swiper-pagination {
                /deep/ .swiper-pagination-bullet {
                    display: inline-block;
                    width: .43rem;
                    height: .07rem;
                    background: rgb(255, 255, 255, .502);
                    border-radius: .3rem;

                }

                /deep/ .swiper-pagination-bullet.swiper-pagination-bullet-active {
                    background: #ffd6ab;
                }
            }
        }

        .slider-img {
            width: 100%;
            height: 100%;
            position: absolute;
            bottom: 0;
        }
    }

    .carousel-list {
        .carousel-item {
            float: left;
        }
    }

    .order-clasess-box {
        position: relative;
        height: 1.62rem;
        margin-bottom: .28rem;
        padding-right: .4rem;
        border-radius: .1rem;
        background-image: url(../assets/home-bg2.png);
        background-size: cover;
        background-position: center;
    }
    .view-plan-box {
        position: relative;
        height: 1.62rem;
        margin-bottom: .28rem;
        padding-right: .4rem;
        border-radius: .1rem;
        background-image: url(../assets/home-bg3.png);
        background-size: cover;
        background-position: center;
    }

    .link-name {
        position: absolute;
        top: 50%;
        right: .4rem;
        transform: translateY(-50%);
        color: #a4805b;
        font-size: .28rem;
        font-weight: 500;

        &::after {
            content: "";
            display: inline-block;
            width: .22rem;
            height: .16rem;
            background-image: url(../assets/double-arrow.png);
            background-repeat: no-repeat;
            background-size: contain;
            margin-left: .08rem;
        }
    }

}
</style>


// WEBPACK FOOTER //
// src/components/home.vue